import type { MutationSuccessOptionsWithDefault } from "./query-mutation-success.type";

import { useQueryClient } from "@tanstack/react-query";

import { getQueryInvalidateKeys } from "../query-invalidate";

export const useMutationOnSuccess = ({
  onSuccess,
  onSuccessAwaited,
  invalidate,
  defaultInvalidate,
}: MutationSuccessOptionsWithDefault = {}) => {
  const queryClient = useQueryClient();

  const { backgroundKeys, awaitedKeys } = getQueryInvalidateKeys({
    invalidate,
    defaultInvalidate,
  });

  return () => {
    // 1 - Non-awaited effects: do not block mutation completion (immediate onSuccess + background invalidations)

    onSuccess?.();

    backgroundKeys.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );

    // 2 - Awaited effects: keep mutation pending until everything resolves (awaited onSuccess + awaited invalidations)

    const awaitedEffects = [
      onSuccessAwaited?.(),
      ...awaitedKeys.map((queryKey) =>
        queryClient.invalidateQueries({ queryKey })
      ),
    ].filter(Boolean);

    if (!awaitedEffects.length) return;

    return Promise.all(awaitedEffects);
  };
};
